import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssinaturaModule } from '../assinatura/assinatura.module';

import { ParlamentarComponent } from './parlamentar.component';

const routes: Routes = [
  {
    path: '',
    component: ParlamentarComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ParlamentarPageRoutingModule {}
